import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faEraser } from "@fortawesome/free-solid-svg-icons";
import { useState } from 'react';
import PropTypes from 'prop-types';

export default function DeleteBtn({ handleOnClick, value, t, small }) {
    const [showModal, setShowModal] = useState(false);

    function handleConfirm() {
        setShowModal(false);
        handleOnClick();
    }

    function handleCancel() {
        setShowModal(false);
    }

    function DeleteConfirm() {
        if (!showModal) return null;

        return (
            <div className="modal show d-block bg-dark" role="dialog" aria-hidden="false" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t("DeletConfirmtitle")}</h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={handleCancel}
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            {t("DeleteConfirmMsg")}
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn-masar-sm btn-med-gray"
                                onClick={handleCancel}
                            >
                                {t("Cancel")}
                            </button>
                            <button
                                type="button"
                                className="btn-masar-sm btn-dark-orange"
                                onClick={handleConfirm}
                            >
                                {t("Delete")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <>
            {small ? (
                <button
                    className={`btn-masar-sm btn-dark-orange rounded position-absolute top-0 end-0 m-0
            ${value === "Rejected" ? `position-absolute top-0 end-0 m-1` : ""}`}
                    onClick={() => setShowModal(true)}
                    value={value}
                    aria-label={t("Delete")}
                >
                    <FontAwesomeIcon icon={faBan} />
                </button>
            ) : (
                <button
                    className={`btn-masar btn-dark-orange text-white p-1 rounded me-3 
            ${value === "Rejected" ? "" : `position-absolute top-0 end-0 m-1`}`}
                    onClick={() => setShowModal(true)}
                    value={value}
                    aria-label={t("Delete")}
                >
                    <FontAwesomeIcon icon={faEraser} />
                </button>
            )}
            <DeleteConfirm />
        </>
    );
}

DeleteBtn.propTypes = {
    handleOnClick: PropTypes.func.isRequired,
    value: PropTypes.string,
    t: PropTypes.func.isRequired,
    small: PropTypes.bool
};

DeleteBtn.defaultProps = {
    value: '',
    small: false
};